import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from '../components/ProjectCard';

const journeyProjects = [
  {
    title: 'Backpacking Through Southeast Asia',
    description: 'Three months exploring Thailand, Vietnam, Cambodia, and Laos, documenting local cuisine and off-the-beaten-path experiences.',
    image: 'https://via.placeholder.com/600x400?text=Southeast+Asia',
    creator: 'Roscoe' as const,
    tags: ['Travel', 'Food', 'Photography'],
    link: '#'
  },
  {
    title: 'Road Trip Across America',
    description: 'A 30-day adventure spanning 15 states, focusing on small towns and local music scenes across the heartland.',
    image: 'https://via.placeholder.com/600x400?text=USA+Road+Trip',
    creator: 'Matthew' as const,
    tags: ['Travel', 'Music', 'Culture'],
    link: '#'
  },
  {
    title: 'Iceland Winter Expedition',
    description: 'A week-long journey chasing the Northern Lights and exploring ice caves during the winter solstice.',
    image: 'https://via.placeholder.com/600x400?text=Iceland',
    creator: 'Both' as const,
    tags: ['Travel', 'Photography', 'Adventure'],
    link: '#'
  },
  {
    title: 'Urban Exploration: Abandoned Places',
    description: 'Documenting forgotten buildings and spaces across major cities, telling the stories of their past glory.',
    image: 'https://via.placeholder.com/600x400?text=Urban+Exploration',
    creator: 'Matthew' as const,
    tags: ['Urban', 'Photography', 'History'],
    link: '#'
  },
  {
    title: 'Mountain Trekking in Nepal',
    description: 'A challenging trek through the Annapurna Circuit, capturing the breathtaking landscapes and local culture.',
    image: 'https://via.placeholder.com/600x400?text=Nepal+Trek',
    creator: 'Roscoe' as const,
    tags: ['Adventure', 'Mountains', 'Culture'],
    link: '#'
  }
];

const JourneysPage: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 px-6 md:px-12 bg-white">
        <div className="container max-w-content mx-auto">
          <motion.div 
            className="max-w-3xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-4xl font-bold mb-6" style={{ color: '#4A90E2' }}>Journeys</h1>
            <p className="text-xl text-dark-gray mb-8">
              Our adventures around the globe, exploring diverse cultures, landscapes, and experiences.
              From urban exploration to wilderness treks, these are the places that have shaped our perspectives.
            </p>
          </motion.div>
        </div>
      </section>
      
      {/* Projects Grid */}
      <section className="py-16 px-6 md:px-12 bg-light-gray">
        <div className="container max-w-content mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {journeyProjects.map((project, index) => (
              <motion.div
                key={project.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <ProjectCard {...project} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Call to Action */}
      <section className="py-16 px-6 md:px-12 bg-white">
        <div className="container max-w-content mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to start your own journey?</h2>
          <p className="text-lg text-dark-gray mb-8 max-w-2xl mx-auto">
            We're always looking for new adventures and collaborations. 
            Get in touch to discuss your ideas or learn more about our experiences.
          </p>
          <a 
            href="mailto:contact@randm.com" 
            className="inline-block px-8 py-3 bg-black text-white font-medium hover:bg-opacity-90 transition-colors"
          >
            Contact Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default JourneysPage; 